"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCountryPaymentGateway = void 0;
const getCountryPaymentGateway = async (supabase, country_id, currency, mode, payment_types = ["Credit_Card"]) => {
    if (!mode || mode == "") {
        mode = "live";
    }
    const { data, error } = await supabase
        .from("countries")
        .select("id, payment_methods(*)")
        .eq("id", country_id);
    if (error) {
        throw new Error(error.message);
    }
    const payment_gateways = data[0].payment_methods.filter((payment_method) => {
        if (payment_types.length > 0) {
            const methods = payment_method.payment_types;
            return (payment_method.currency_config.includes(currency) &&
                methods.some((method) => payment_types.includes(method)));
        }
        return payment_method.currency_config.includes(currency);
    });
    // for each payment gateway, filter the fee config to only include the currency we are looking for
    for (let i = 0; i < payment_gateways.length; i++) {
        const gateway = payment_gateways[i];
        gateway.fee_config.filter((fee_config) => {
            return fee_config.currencies.includes(currency);
        });
        gateway.api_config = gateway.api_config.filter((config) => {
            return config.env == mode;
        });
    }
    return payment_gateways.map((gateway) => {
        return {
            id: gateway.id,
            payment_types: gateway.payment_types,
            name: gateway.name,
            api_config: gateway.api_config[0],
            fees: gateway.fee_config,
        };
    });
};
exports.getCountryPaymentGateway = getCountryPaymentGateway;
